export const version = '3.0.0-alpha.3';
